"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export type PromotionCodeProvider = {
  code: string;
  imageUrl: string;
};

export const promotionInputs = [
  {
    name: "title",
    type: "string",
    defaultValue: "Promotion Title",
    required: true,
  },
  {
    name: "description",
    type: "string",
    defaultValue: "Promotion Description",
    required: true,
  },
  {
    name: "successMessage",
    type: "string",
    defaultValue: "Success Message",
    required: true,
  },
  {
    name: "errorMessage",
    type: "string",
    defaultValue: "Error Message",
    required: true,
  },
  {
    name: "providers",
    type: "list",
    required: true,
    subFields: [
      {
        name: "code",
        type: "string",
        required: true,
      },
      {
        name: "imageUrl",
        type: "string",
        required: true,
      },
    ],
    defaultValue: [],
  },
] as const satisfies Inputs;

export const PromotionComponent: RegisteredComponent = {
  name: "Promotion",
  component: dynamic(async () =>
    withValidation(
      promotionInputs,
      (await import("./Promotion")).Promotion,
      "Promotion"
    )
  ),
  inputs: promotionInputs,
};
